import { Component, OnInit } from '@angular/core';
import { StrapiMedia } from '@portals/api';
import { BaseComponent, DrawerService } from '@portals/core';

@Component({
	selector: 'portals-detail-drawer',
	templateUrl: './detail-drawer.component.html',
	styleUrls: ['./detail-drawer.component.scss'],
})
export class DetailDrawerComponent extends BaseComponent implements OnInit {
	latitude!: number;
	longitude!: number;
	location_name!: string;
	images: Array<StrapiMedia> = [];

	get summarySection() {
		// @ts-ignore
		return this.drawer.context[2] as Record<string, unknown>;
	}

	constructor(public drawer: DrawerService<Record<string, unknown>>) {
		super();
	}

	ngOnInit(): void {
		//@ts-ignore
		this.latitude = this.drawer?.context[1]?.latitude;
		//@ts-ignore
		this.longitude = this.drawer?.context[1]?.longitude;
		//@ts-ignore
		this.location_name = this.drawer?.context[3]?.location;
		const { images } = (this.drawer.context![0] as {
			images: StrapiMedia[];
		}) || { images: [] };
		this.images = images;
	}
}
